import React from "react";
import BusinessMenuItems from "../layout/business-menu-items";
import { useState, useContext } from "react";
import { useRouter } from "next/router";
import BusinessContext from "../../contexts/business-context";
import UserContext from "../../contexts/user-context";
import ActionIcon from "./action-icon";
import { ChevronRight, ChevronLeft } from "lucide-react";
import SideBarContext from "../../contexts/side-bar-context";
import NameInitialWrapper from "./name-initial-wrapper";

const ProfileCard = ({ toggleSidebar, isOpen, additionalclasses, toggle, email }) => {
  const router = useRouter();
  const businessCtx = useContext(BusinessContext);
  const business = businessCtx.activeBusiness;

  const userCtx = useContext(UserContext);
  const user = userCtx.user;

  const { isSideBarOpen } = useContext(SideBarContext);


  const [isBusinessDropdownOpen, setBusinessDropdownOpen] = useState(false);
  return (
    <div onClick={toggle ? () => setBusinessDropdownOpen((prev) => !prev) : undefined} className={`flex ${(!user.is_pseudonymous === true && isSideBarOpen) ? ' ' : ''} cursor-pointer custom-bg-white-200 justify-between items-center content-center px-[10px] pt-[16px] border-t-[1px] custom-border-grey-50 ${additionalclasses}`}>
      <div className="flex gap-[4.67px] items-center justify-start content-center ">
        <div className="w-[40px] h-[40px]">
          <NameInitialWrapper name={user?.first_name} email={user?.email}>
            {user?.first_name[0]}
          </NameInitialWrapper>
        </div>
        <div className="grid grid-flow-col gap-[4px]">
          <div className="grid gap-[6px]">
            <span className="custom-text-grey-800  poppins-bold text-[14px] leading-[12px] truncate">
              {user?.first_name}
            </span>
            {!email && <span className="custom-text-grey-200  text-[14px] truncate poppins-regular truncate">
              {business?.name}
            </span>}
            {email && <span className="custom-text-grey-200  text-[14px] truncate poppins-regular truncate">
              {user.email}
            </span>}

          </div>
        </div>
      </div>
      {toggle && <ActionIcon color='custom-text-grey-800'>
        {isBusinessDropdownOpen ? <ChevronLeft size={18} color="currentColor" /> : <ChevronRight size={18} />}
      </ActionIcon>}
      {isBusinessDropdownOpen && (
        <BusinessMenuItems
          open={isBusinessDropdownOpen}
          setIsOpen={setBusinessDropdownOpen}
        />
      )}
    </div>
  );
};

export default ProfileCard;
